import { useTranslation } from 'react-i18next';

import { Box, Card, CardContent, Grid, Link, Paper, SvgIcon, Typography } from '@mui/material';

import { BugIcon, FishHookIcon, TargetIcon } from '@/utils/iconSVG';

import {
  stylesSecurityPolicyCard,
  stylesSecurityPolicyPaper,
  stylesSecurityPolicyCardIcon,
  stylesSecurityPolicyCardContent,
  stylesSecurityPolicyCardContainer,
} from './SecurityPolicy.styles';

export function SecurityPolicy() {
  const { t } = useTranslation('customsPass_securityPolicyPage');

  return (
    <>
      <Typography variant='h1' mb={3}>
        {t('securityPolicy.title')}
      </Typography>
      <Paper sx={stylesSecurityPolicyPaper}>
        <Typography variant='h3' mb={2}>
          {t('securityPolicy.notifyUs')}
        </Typography>
        <Typography variant='bodyMD' mb={3} component='p'>
          {t('securityPolicy.privacy.text1')}
          <br />
          {t('securityPolicy.privacy.text2')}
        </Typography>
        <Typography variant='bodyMD' component='div' fontWeight='fontWeightMedium' mb={2}>
          {t('securityPolicy.alertSubjects')}
        </Typography>
        <Grid container spacing={2} mb={4}>
          <Grid item xs={4}>
            <Card sx={stylesSecurityPolicyCard} variant='outlined'>
              <SvgIcon component={BugIcon} sx={stylesSecurityPolicyCardIcon} />
              <Box sx={stylesSecurityPolicyCardContainer}>
                <CardContent sx={stylesSecurityPolicyCardContent}>
                  <Typography variant='bodyMD' component='div'>
                    {t('securityPolicy.vulnerabilitiesOrFlaws')}
                  </Typography>
                </CardContent>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card sx={stylesSecurityPolicyCard} variant='outlined'>
              <SvgIcon component={TargetIcon} sx={stylesSecurityPolicyCardIcon} />
              <Box sx={stylesSecurityPolicyCardContainer}>
                <CardContent sx={stylesSecurityPolicyCardContent}>
                  <Typography variant='bodyMD' component='div'>
                    {t('securityPolicy.dataExposedPublicly')}
                  </Typography>
                </CardContent>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card sx={stylesSecurityPolicyCard} variant='outlined'>
              <SvgIcon component={FishHookIcon} sx={stylesSecurityPolicyCardIcon} />
              <Box sx={stylesSecurityPolicyCardContainer}>
                <CardContent sx={stylesSecurityPolicyCardContent}>
                  <Typography variant='bodyMD' component='div'>
                    {t('securityPolicy.fishing')}
                  </Typography>
                </CardContent>
              </Box>
            </Card>
          </Grid>
        </Grid>
        <Typography variant='h3' mb={2}>
          {t('securityPolicy.toContactUs')}
        </Typography>
        <Typography variant='bodyMD' mb={3} component='p'>
          {t('securityPolicy.sendMailTo')}
          <Link href={`mailto:${process.env.REACT_APP_SECURITY_EMAIL_ADDRESS}`} fontWeight='regular'>
            {process.env.REACT_APP_SECURITY_EMAIL_ADDRESS}
          </Link>
        </Typography>
        <Typography variant='bodyMD' component='div' fontWeight='fontWeightMedium' mb={2}>
          {t('securityPolicy.inOrderToBestProcess')}
        </Typography>
        <Card variant='outlined' sx={{ width: 'fit-content', mb: 4 }}>
          <CardContent sx={{ p: 3 }}>
            <Box component='ul' sx={{ pl: 3, m: 0 }}>
              <Typography component='li' variant='bodyMD'>
                {t('securityPolicy.clearDescription')}
              </Typography>
              <Typography component='li' variant='bodyMD'>
                {t('securityPolicy.platform')}
              </Typography>
              <Typography component='li' variant='bodyMD'>
                {t('securityPolicy.urlAndIPAddress')}
              </Typography>
              <Typography component='li' variant='bodyMD'>
                {t('securityPolicy.proof')}
              </Typography>
              <Typography component='li' variant='bodyMD'>
                {t('securityPolicy.impact')}
              </Typography>
            </Box>
          </CardContent>
        </Card>
        <Typography variant='h3' mb={2}>
          {t('securityPolicy.responsabilities')}
        </Typography>
        <Typography variant='bodyMD' mb={3} component='p'>
          {t('securityPolicy.preciseAsPossibleTheProblem')}
        </Typography>
        <Typography variant='h3' mb={2}>
          {t('securityPolicy.processingAlert')}
        </Typography>
        <Typography variant='bodyMD' mb={3} component='p'>
          {t('securityPolicy.dealWithProblem')}
        </Typography>
        <Typography variant='h3' mb={2}>
          {t('securityPolicy.privacyPolicy')}
        </Typography>
        <Typography variant='bodyMD' mb={3} component='p'>
          {t('securityPolicy.systemInformation')}
        </Typography>
      </Paper>
    </>
  );
}
